import axios from 'axios';
import { setupAxiosInterceptor } from './auth/axiosConfig';
import config from './config';

// Human presence (Support V1 phase 3; backend py/cellcog/api/presence.py, Arjun's design CEL-3859 section 1).
const api = axios.create({
  baseURL: config.API_BASE_URL + '/cellcog',
  headers: { 'Content-Type': 'application/json' },
});

setupAxiosInterceptor(api);

// The app's heartbeat: only from a VISIBLE tab with input in the last ~2 minutes (contexts/PresenceContext decides when).
export const pingPresence = () => api.post('/presence/ping', {});

// {online: [user ids], away}: who of these people is online now (people only; the viewer's org mates only).
export const getPresence = (userIds) => api.get('/presence', { params: { ids: (userIds || []).join(',') } });

// The profile menu's "Set yourself as away" / back online. Stays until changed.
export const setPresenceAway = (away) => api.put('/presence/away', { away: !!away });
